import { Button } from 'components/ui/button';
import { DropdownMenuItem } from 'components/ui/dropdown-menu';
import { LockProtection } from 'components/shared/LockProtection';

export const LockableButton = LockProtection(Button);
export const LockableDropdownMenuItem = LockProtection(DropdownMenuItem);
